import React, { useContext, useCallback } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const Context = React.createContext()

export function InfractionsContext({ infractionsByFieldName, ...props }) {
  return <Context.Provider {...props} value={infractionsByFieldName} />
}

InfractionsContext.propTypes = {
  infractionsByFieldName: PropTypes.object
}

/**
 * @returns {(fieldPath: string, { isPrefix: boolean }) => null | Object | Object[]}
 */
export function useInfractionGetter() {
  const infractionsByFieldName = useContext(Context)

  return useCallback(
    (fieldPath, { isPrefix = false } = {}) => {
      if (isPrefix) {
        return _(infractionsByFieldName)
          .filter(
            infraction =>
              infraction.status !== 'Resolved' &&
              infraction.status !== 'Ignored'
          )
          .filter(infraction => infraction.fieldName.startsWith(fieldPath))
          .value()
      } else {
        return infractionsByFieldName?.[fieldPath]?.status !== 'Resolved' &&
          infractionsByFieldName?.[fieldPath]?.status !== 'Ignored'
          ? infractionsByFieldName?.[fieldPath]
          : null
      }
    },
    [infractionsByFieldName]
  )
}
